export default "__VITE_ASSET__Cly1xgzi__"